import React, { Component } from 'react';
import { connect } from 'react-redux';
import CustomerWaitTime from './CustomerWaitTime';
import analyticsRemote from '../../../api/analyticsRemote';
import { ExportToCsv } from 'export-to-csv';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import AirlineType from '../../../models/AirlineType';
import ForwarderModel from '../../../models/ForwarderAwb';

import { receiveError } from '../../../store/actions/notificationAction';
import moment, { Moment } from 'moment';
import { SEARCH_OPTIONS_SCHEMA, QUERY_OPTIONS_SCHEMA, CUSTOMER_WAIT_GRAPH_SCHEMA, CUSTOMER_WAIT_AVERAGE_SCHEMA } from '../../../utils/Analytics';
import { CustomerWaitSearchOption, CustomerWaitQuery, CustomerWaitGraphData, CustomerWaitAVG, OrdersData, ItemData, UserData, custData, filterOptions } from '../../../models/Analytics';
import DeliveryCompany from '../../../models/DeliveryCompany';

interface CustomerWaitTimeContainerState {
  searchOptions: CustomerWaitSearchOption;
  filterOptions: filterOptions;
  queryOptions: CustomerWaitQuery;
  avgData: Array<any>;
  day_diff: number;
  type: string;
  progress: boolean;
  graphData: CustomerWaitGraphData;
  queryResult: number;
  intvl: number;
  average: CustomerWaitAVG;
  dataView: boolean;
  airlines: AirlineType[];
  forwarders: ForwarderModel[];
  companies: DeliveryCompany[];
  drivers: Array<string>;
  users: UserData[];
  orders: OrdersData[];
  data: OrdersData[];
  exceedHours: number;
};

interface CustomerWaitTimeContainerProps {
  receiveError: Function;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
  handleChangeDate: (dateType: string, event: any) => void;
};


class CustomerWaitTimeContainer extends Component<CustomerWaitTimeContainerProps, CustomerWaitTimeContainerState> {

  state = {
    filterOptions: {
      process: true,
      carriers: true,
      forwarders: true,
      gha: true,
      cust_err: true,
      appt: true,
    },
    searchOptions: { ...SEARCH_OPTIONS_SCHEMA, startDate: this.props.startDate, endDate: this.props.endDate },
    queryOptions: QUERY_OPTIONS_SCHEMA,
    avgData: [],
    day_diff: 1,
    type: 'AVG',
    progress: false,
    graphData: CUSTOMER_WAIT_GRAPH_SCHEMA,
    queryResult: 0,
    intvl: 2,
    average: CUSTOMER_WAIT_AVERAGE_SCHEMA,
    dataView: false,
    airlines: this.props.airlines,
    forwarders: [],
    companies: [],
    drivers: [],
    users: [],
    orders: [],
    data: [],
    exceedHours: 0,
  }

  componentWillReceiveProps(nextProps: CustomerWaitTimeContainerProps) {
    let searchOptions = this.state.searchOptions;
    if (nextProps.startDate !== this.state.searchOptions.startDate || nextProps.endDate !== this.state.searchOptions.endDate) {
      searchOptions.startDate = nextProps.startDate;
      searchOptions.endDate = nextProps.endDate;
      this.setState({ searchOptions }, () => {
        this.loadOdersData();
      });
    }
    if (nextProps.airlines != this.state.airlines) {
      let carr = nextProps.airlines.map((a: AirlineType) => a.iata_code);
      this.setState({ airlines: nextProps.airlines, searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
  }

  componentDidMount() {
    if (this.state.airlines.length > 0) {
      let carr = this.state.airlines.map(a => a.iata_code);
      this.setState({ searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
    this.loadOdersData();
  }

  loadOdersData = (): void => {
    this.setState({ progress: true }, () => {
      let searchOptions = this.state.searchOptions;
      let startDate: string = searchOptions.startDate.format('YYYYMMDD');
      let endDate: string = searchOptions.endDate.format('YYYYMMDD');
      let pickUp: boolean = searchOptions.pickUp;
      let dropOff: boolean = searchOptions.dropOff;
      analyticsRemote.getOrdersData(
        startDate,
        endDate,
        pickUp,
        dropOff,
        this.state.exceedHours
      ).then((resp: ApiResponse<Array<OrdersData>>) => {
        const data: Array<OrdersData> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (data) {
          this.setState({ data, searchOptions: { ...this.state.searchOptions, fwd_id: 0, trk_cmp: 0, drv_name: '', gha_id: 0 } }, () => {
            this.resetFilter();
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
        this.setState({ progress: false });
      });
    })
    
  }

  resetFilter = (): void => {
    this.setState({ searchOptions: { ...this.state.searchOptions, fwd_id: 0, trk_cmp: 0, drv_name: '', gha_id: 0 } }, () => {
      this.filterOdersData();
    });
  }

  filterOdersData = (): void => {
    let orders = this.state.airlines.length > 0 && this.state.searchOptions.carr != '' ? this.state.data : [];
    // Show Apointments Only
    if (this.state.searchOptions.appt) {
      orders = orders.filter((o: OrdersData) => {
        if (!o.isManualEntry)
          return o;
      })
    }
    // Exclude Customer Errors
    if (this.state.searchOptions.error) {
      orders = orders.filter((o: OrdersData) => {
        let err = false;
        o.items.map((i: ItemData) => {
          if (i.remarks && i.remarks.customer_error) {
            err = true;
          }
        })
        if (!err)
          return o;
      })
    }
    // Handled Carriers
    if (this.state.searchOptions.carr && this.state.searchOptions.carr != '') {
      orders = orders.filter((o: OrdersData) => {
        let carr = false;
        o.items.map((i: ItemData) => {
          if (i.iata_code && this.state.searchOptions.carr.includes(i.iata_code)) {
            carr = true;
          }
        })
        if (carr)
          return o;
      })
    }
    // Forwarders
    if (this.state.searchOptions.fwd_id && this.state.searchOptions.fwd_id != 0) {
      orders = orders.filter((o: OrdersData) => {
        if (this.state.searchOptions.fwd_id == o.id_forwarder)
          return o;
      })
    }
    // Trucking Company
    if (this.state.searchOptions.trk_cmp && this.state.searchOptions.trk_cmp != 0) {
      orders = orders.filter((o: OrdersData) => {
        if (this.state.searchOptions.trk_cmp == o.id_delivery_company)
          return o;
      })
    }
    // Specific Truck Driver
    if (this.state.searchOptions.drv_name && this.state.searchOptions.drv_name != '') {
      orders = orders.filter((o: OrdersData) => {
        if (this.state.searchOptions.drv_name == o.driver_name)
          return o;
      })
    }
    // Specific GHA Employee
    if (this.state.searchOptions.gha_id && this.state.searchOptions.gha_id != 0) {
      orders = orders.filter((o: OrdersData) => {
        if (this.state.searchOptions.gha_id == o.id_gha_user_worked_on || this.state.searchOptions.gha_id == o.id_forwarder_user)
          return o;
      })
    }
    this.setState({ orders }, () => {
      this.calAvgData();
      this.calQueryData();
      this.getForwarder();
      this.getCompany();
      this.getDrivers();
      this.getUser();
    });
  }

  handleExceedHoursChange = (value: any): void => {
    // Convert empty string or null to undefined
    const parsedValue = value === '' || value === null ? undefined : value;
    
    this.setState({ exceedHours: parsedValue }, () => {
      this.loadOdersData();
    });
  }


  getForwarder = (): void => {
    const forwarders: Array<ForwarderModel> = this.state.orders.map((o: OrdersData) => { return o.forwarder });
    this.setState({
      forwarders: forwarders.reduce((unique: Array<ForwarderModel>, o: ForwarderModel) => {
        if (o && !unique.some((obj: ForwarderModel) => obj.id === o.id)) {
          unique.push(o);
        }
        return unique;
      }, [])
    })
  };

  getCompany = (): void => {
    const companies = this.state.orders.map((o: OrdersData) => {
      return o.company;
    })
    this.setState({
      companies: companies.reduce((unique: Array<DeliveryCompany>, o: DeliveryCompany) => {
        if (o && !unique.some((obj: DeliveryCompany) => obj.id && o.id && obj.id === o.id)) {
          unique.push(o);
        }
        return unique;
      }, [])
    })
  };

  getUser = (): void => {
    const users: UserData[] = [];
    this.state.orders.map((o: OrdersData) => {
      if (o.gha)
        users.push(o.gha);
      if (o.forwarder_user)
        users.push(o.forwarder_user);
    })
    this.setState({
      users: users.reduce((unique: Array<UserData>, o: UserData) => {
        if (o && !unique.some((obj: UserData) => obj.id === o.id)) {
          unique.push(o);
        }
        return unique;
      }, [])
    })
  };

  getDrivers = (): void => {
    const drivers: string[] = this.state.orders.map((o: OrdersData) => {
      return o.driver_name;
    })
    this.setState({
      drivers: drivers.reduce((unique: Array<string>, o: string) => {
        if (o && !unique.some((obj: string) => obj === o)) {
          unique.push(o);
        }
        return unique;
      }, [])
    })
  }


  handleChangeProcess = (type: string, value: boolean): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: value };
    this.setState({ searchOptions: searchOptions }, () => {
      ['pickUp', 'dropOff'].includes(type) ? this.loadOdersData() : this.resetFilter();
    });
  }

  handleChange = (type: string, event: any): void => {
    switch (type) {
      case 'type':
        this.setState({ type: event });
        break;
      case 'intvl':
        this.setState({ intvl: event }, () => {
          this.calAvgData();
        });
        break;
      default:
        break;
    }
  }

  handleChangeCarriers = (type: string, value: boolean): void => {
    const searchOptions = { ...this.state.searchOptions };
    let carr = searchOptions.carr.split(",")
    if (type == 'GLOABL' && !value) {
      carr = [];
      searchOptions.carrCheck = value;
    } else if (type == 'GLOABL' && value) {
      carr = this.state.airlines.map(a => a.iata_code);
      searchOptions.carrCheck = value;
    } else {
      if (value) {
        carr.push(type);
      } else {
        var index = carr.indexOf(type);
        if (index !== -1) {
          carr.splice(index, 1);
        }
      }
    }
    searchOptions.carr = carr.toString();
    this.setState({ searchOptions: searchOptions }, () => {
      this.resetFilter();
    });
  }

  handleChangeOption = (type: string, event: any): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: event.value }
    this.setState({ searchOptions: searchOptions }, () => {
      this.filterOdersData();
    });
  }


  handleChangeQuery = (type: string, cmp: string, value: number): void => {
    this.setState({ queryOptions: { type, cmp, value } }, () => {
      this.calQueryData();
    });
  }

  handleChangeDataView = (value: boolean): void => {
    this.setState({ dataView: value });
  }
  handleExport = (): void => {
    let headers = ['Measure'];
    let start = 0;
    while (start < 24) {
      headers.push(start + '-' + (start + this.state.intvl));
      start = start + this.state.intvl;
    }
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: 'Counter Wait Time',
      title: 'Counter Wait Time',
      useTextFile: false,
      useBom: false,
      useKeysAsHeaders: false,
      headers
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.state.avgData.map((d: any) => {
      return {
        ...d,
        tableData: ''
      };
    }));
  }
  calQueryData = (): void => {
    let queryResult = 0;
    this.state.orders.map((o: OrdersData) => {
      if (this.state.queryOptions.type == 'AWBS') {
        if (this.state.queryOptions.cmp == 'LT' && o.items.length < this.state.queryOptions.value) {
          queryResult++;
        }
        if (this.state.queryOptions.cmp == 'GT' && o.items.length > this.state.queryOptions.value) {
          queryResult++;
        }
      }
      if (this.state.queryOptions.type == 'PCS') {
        let pcs_sum = o.items.reduce((partialSum, a) => partialSum + a.pieces, 0);
        if (this.state.queryOptions.cmp == 'LT' && pcs_sum < this.state.queryOptions.value) {
          queryResult++;
        }
        if (this.state.queryOptions.cmp == 'GT' && pcs_sum > this.state.queryOptions.value) {
          queryResult++;
        }
      }
      if (this.state.queryOptions.type == 'WGT') {
        let wgt_sum = o.items.reduce((partialSum, a) => partialSum + a.weight, 0);
        if (this.state.queryOptions.cmp == 'LT' && wgt_sum < this.state.queryOptions.value) {
          queryResult++;
        }
        if (this.state.queryOptions.cmp == 'GT' && wgt_sum > this.state.queryOptions.value) {
          queryResult++;
        }
      }
    })
    this.setState({ queryResult });
  }

  calAvgData = (): void => {
    let cont_wait = 0;
    let cont_pros = 0;
    let whse_wait = 0;
    let whse_pros = 0;
    let total = 0;
    let long_time = 0;
    let short_time = 0;
    let awb_min = 0;
    let awb_avg = 0;
    let awb_max = 0;
    let pcs_min = 0;
    let pcs_max = 0;
    let pcs_avg = 0;
    let wgt_min = 0;
    let wgt_max = 0;
    let wgt_avg = 0;
    let total_awb = 0;
    let total_awb_pcs = 0;
    let total_awb_wgt = 0;
    let gData: custData[] = [];
    for (let i = 0; i < 24; i += this.state.intvl) {
      gData.push({ orders: 0, cont_wait: 0, cont_pros: 0, whse_wait: 0, whse_pros: 0, total: 0 });
    }
    this.state.orders.map((o: OrdersData) => {
      let time = o.pickup_date + ' ' + (o.pickup_time ? o.pickup_time.replace(/([\d]{2})([\d]{2})/, '$1:$2') : '00:00')
      let index = parseInt((moment(time, 'YYYYMMDD HH:mm').hour() / this.state.intvl).toString());
      gData[index].orders++;
      let c_wait = o.driver.created ? moment(o.create_date).diff(moment(o.driver.created), 'minute') || 0 : 0;
      if (c_wait < 0) {
        c_wait = 0  // if driver time greater then order time
      }
      let c_pros = moment(o.green_timestamp).diff(moment(o.create_date), 'minute') || 0;
      let w_wait = moment(o.dock_timestamp).diff(moment(o.green_timestamp), 'minute') || 0;
      let w_pros = moment(o.delivered_timestamp).diff(moment(o.dock_timestamp), 'minute') || 0;
      let c_tol = c_wait + c_pros + w_wait + w_pros;
      if (this.state.searchOptions.gha_id && this.state.searchOptions.gha_id != 0) {
        if (o.id_gha_user_worked_on == this.state.searchOptions.gha_id) {
          c_tol = w_wait + w_pros;
          whse_wait += w_wait;
          gData[index].whse_wait += w_wait;
          whse_pros += w_pros + w_wait;
          gData[index].whse_pros += w_pros + w_wait;
        }
        if (o.id_forwarder_user == this.state.searchOptions.gha_id) {
          c_tol = c_wait + c_pros;
          cont_wait += c_wait;
          gData[index].cont_wait += c_wait;
          cont_pros += c_pros;
          gData[index].cont_pros += c_pros;
        }
      } else {
        cont_wait += c_wait;
        gData[index].cont_wait += c_wait;
        cont_pros += c_pros;
        gData[index].cont_pros += c_pros;
        whse_wait += w_wait;
        gData[index].whse_wait += w_wait;
        whse_pros += w_pros + w_wait;
        gData[index].whse_pros += w_pros + w_wait;
      }
      gData[index].total += c_tol;
      total += c_tol;
      if (short_time = 0) {
        short_time = c_tol;
      }
      if (c_tol < short_time) {
        short_time = c_tol;
      }
      if (c_tol > long_time) {
        long_time = c_tol;
      }

      //Awbs per order
      total_awb += o.items.length;
      if (awb_min == 0) {
        awb_min = o.items.length;
      }
      if (o.items.length < awb_min) {
        awb_min = o.items.length;
      }
      if (o.items.length > awb_max) {
        awb_max = o.items.length;
      }

      //Pieces per order
      let pcs_sum = o.items.reduce((partialSum, a) => partialSum + a.pieces, 0);
      total_awb_pcs += pcs_sum;
      if (pcs_min == 0) {
        pcs_min = pcs_sum;
      }
      if (pcs_sum < pcs_min) {
        pcs_min = pcs_sum;
      }
      if (pcs_sum > pcs_max) {
        pcs_max = pcs_sum;
      }

      //Weight per order
      let wgt_sum = o.items.reduce((partialSum, a) => partialSum + a.weight, 0);
      total_awb_wgt += wgt_sum;
      if (wgt_min == 0) {
        wgt_min = wgt_sum;
      }
      if (wgt_sum < wgt_min) {
        wgt_min = wgt_sum;
      }
      if (wgt_sum > wgt_max) {
        wgt_max = wgt_sum;
      }
    })
    let col = [
      {
        label: 'Average Waiting For Service Time',
        key: 'cont_wait',
        avg: true
      },
      {
        label: 'Average Counter Process Time',
        key: 'cont_pros',
        avg: true
      },
      // {
      //   label: 'Average Warehouse Wait Time',
      //   key: 'whse_wait',
      //   avg: true
      // },
      {
        label: 'Average Warehouse Process Time',
        key: 'whse_pros',
        avg: true
      },
      {
        label: 'Average Total Wait Time',
        key: 'total',
        avg: true
      },
      {
        label: 'Average Number of Orders',
        key: 'orders',
        avg: true
      }
    ];
    let day_diff = (this.state.searchOptions.endDate.diff(this.state.searchOptions.startDate, 'days') || 0) + 1
    let avgData = col.map(c => {
      let cData = gData.map((g: any) => {
        if (g.orders > 0) {
          if (g[c.key] && c.avg) {
            if (c.key == 'orders') {
              let value = Math.ceil(g[c.key] / day_diff)
              return value % 1 !== 0 ? value.toFixed(2) : value
            } else {
              return Math.round(g[c.key] / g.orders);
            }
          } else if (g[c.key]) {
            return Math.round(g[c.key]);
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      })
      return [c.label, ...cData];
    })

    let graphData = {
      orders: gData.map(g => Math.ceil(g.orders / day_diff)),
      cont_wait: gData.map(g => Math.round(g.cont_wait / g.orders)),
      cont_pros: gData.map(g => Math.round(g.cont_pros / g.orders)),
      whse_wait: gData.map(g => Math.round(g.whse_wait / g.orders)),
      whse_pros: gData.map(g => Math.round(g.whse_pros / g.orders)),
    }

    cont_wait = Math.round(cont_wait / this.state.orders.length) || 0;
    cont_pros = Math.round(cont_pros / this.state.orders.length) || 0;
    whse_wait = Math.round(whse_wait / this.state.orders.length) || 0;
    whse_pros = Math.round(whse_pros / this.state.orders.length) || 0;
    total = Math.round(total / this.state.orders.length) || 0;
    awb_avg = Math.round(total_awb / this.state.orders.length || 0);
    pcs_avg = Math.round(total_awb_pcs / this.state.orders.length) || 0;
    wgt_avg = Math.round(total_awb_wgt / this.state.orders.length) || 0;
    this.setState({
      day_diff,
      avgData,
      graphData,
      average: {
        cont_wait,
        cont_pros,
        whse_wait,
        whse_pros,
        total,
        long_time,
        short_time,
        awb_min,
        awb_avg,
        awb_max,
        pcs_min,
        pcs_max,
        pcs_avg,
        wgt_min,
        wgt_max,
        wgt_avg,
      }
    });
  }

  render() {
    return (
      <CustomerWaitTime
        startDate={this.state.searchOptions.startDate}
        endDate={this.state.searchOptions.endDate}
        progress={this.state.progress}
        pickUp={this.state.searchOptions.pickUp}
        dropOff={this.state.searchOptions.dropOff}
        error={this.state.searchOptions.error}
        carrCheck={this.state.searchOptions.carrCheck}
        carr={this.state.searchOptions.carr}
        appt={this.state.searchOptions.appt}
        fwd_id={this.state.searchOptions.fwd_id}
        trk_cmp={this.state.searchOptions.trk_cmp}
        intvl={this.state.intvl}
        day_diff={this.state.day_diff}
        drv_name={this.state.searchOptions.drv_name}
        gha_id={this.state.searchOptions.gha_id}
        query={this.state.queryOptions}
        queryResult={this.state.queryResult}
        filterOptions={this.state.filterOptions}
        handleChangeQuery={this.handleChangeQuery}
        handleChangeDate={this.props.handleChangeDate}
        average={this.state.average}
        type={this.state.type}
        avgData={this.state.avgData}
        graphData={this.state.graphData}
        airlines={this.state.airlines}
        forwarders={this.state.forwarders}
        companies={this.state.companies}
        drivers={this.state.drivers}
        users={this.state.users}
        dataView={this.state.dataView}
        handleChangeDataView={this.handleChangeDataView}
        handleChangeProcess={this.handleChangeProcess}
        handleChangeCarriers={this.handleChangeCarriers}
        handleChangeOption={this.handleChangeOption}
        handleChange={this.handleChange}
        handleExport={this.handleExport}
        handleExceedHoursChange={this.handleExceedHoursChange}
        exceedHours={this.state.exceedHours} 
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerWaitTimeContainer);